import React from "react";
import { AppearanceContextType, useAppearanceContext } from "@contexts/AppearanceContext";
import "./LifeAtCheckbox.scss";

interface LifeAtCheckboxProps {
    readonly checked: boolean;
    readonly handleToggle?: (e?: React.MouseEvent<HTMLDivElement> | React.ChangeEvent<HTMLInputElement>) => void;
    readonly isDisabled?: boolean;
    readonly label?: string;
    className?: string;
    id?: string;
}
export default function LifeAtCheckbox(props: LifeAtCheckboxProps) {
    const { lightMode }: AppearanceContextType = useAppearanceContext();

    const checkmarkIcon = (
        <svg
            className={`checkbox-checkmark ${props.checked ? "checked" : null} ${lightMode ? "light" : "dark"}`}
            viewBox="4 4 16 18"
        >
            <polyline points="20 6 9 17 4 12" />
        </svg>
    );

    // Inspiration from: https://medium.com/@colebemis/building-a-checkbox-component-with-react-and-styled-components-8d3aa1d826dd
    return (
        <div className={`lifeat-checkbox ${lightMode ? "light" : "dark"} ${props.className}`}>
            {/* This is what stores the state of our checkbox and the data. */}
            <input
                id={props.id}
                className={`hidden-checkbox ${lightMode ? "light" : "dark"}`}
                type="checkbox"
                checked={props.checked}
                onChange={props.handleToggle}
                disabled={props.isDisabled}
                readOnly
            />

            {/* This is what the user actually sees. */}
            {props.label && <label>{props.label}</label>}
            <div
                className={`styled-checkbox ${props.className} ${lightMode ? "light" : "dark"} ${
                    props.isDisabled && "disabled"
                }`}
                onClick={!props.isDisabled ? props.handleToggle : () => {}}
            >
                {/* Dynamically show the check icon */}
                {props.checked ? checkmarkIcon : null}
            </div>
        </div>
    );
}
